<template>
  <div v-if="form">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <template v-for="item in formConfig">

        <a-form-model-item v-if="item.type=='input'" 
        :label="item.label" 
        :prop="item.prop" 
        :key="item.prop"
        :required="item.required"
        :placeholder="item.placeholder"
        >
          <a-input v-model="form[item.prop]"/>
        </a-form-model-item>

        <a-form-model-item v-if="item.type=='password'" 
        :label="item.label" 
        :prop="item.prop" 
        :key="item.prop"
        :required="item.required"
        :placeholder="item.placeholder">
          <a-input v-model="form[item.prop]" type="password"/>
        </a-form-model-item>

      </template>
      <!-- <a-form-model-item ref="name" label="Activity name" prop="name">
        <a-input
          v-model="form.name"
          @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item label="Activity zone" prop="region">
        <a-select v-model="form.region" placeholder="please select your zone">
          <a-select-option value="shanghai"> Zone one </a-select-option>
          <a-select-option value="beijing"> Zone two </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Activity time" required prop="date1">
        <a-date-picker
          v-model="form.date1"
          show-time
          type="date"
          placeholder="Pick a date"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="Activity type" prop="type">
        <a-checkbox-group v-model="form.type">
          <a-checkbox value="1" name="type"> Online </a-checkbox>
          <a-checkbox value="2" name="type"> Promotion </a-checkbox>
          <a-checkbox value="3" name="type"> Offline </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="Resources" prop="resource">
        <a-radio-group v-model="form.resource">
          <a-radio value="1"> Sponsor </a-radio>
          <a-radio value="2"> Venue </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="Activity form" prop="desc">
        <a-input v-model="form.desc" type="textarea" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="onSubmit"> Create </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">
          Reset
        </a-button>
      </a-form-model-item> -->
    </a-form-model>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: Object,
      required: false,
    },
    formConfig: {
      type: [Array],
      required: true,
    },
    colNumber: {
      type: Number,
      required: false,
      default: function () {
        return 1;
      },
    },
  },
  name: "edit-form",
  components: {},
  data() {
    return {
      formName: "editForm" + new Date().getTime(),
      copySource: this.utils.deepClone(this.source),

      labelCol: { span: 5 },
      wrapperCol: { span: 13 },
      other: "",
      form: null,
      // rules: {
      //   name: [
      //     {
      //       required: true,
      //       message: "Please input Activity name",
      //       trigger: "blur",
      //     },
      //     {
      //       min: 3,
      //       max: 5,
      //       message: "Length should be 3 to 5",
      //       trigger: "blur",
      //     },
      //   ],
      //   region: [
      //     {
      //       required: true,
      //       message: "Please select Activity zone",
      //       trigger: "change",
      //     },
      //   ],
      //   date1: [
      //     { required: true, message: "Please pick a date", trigger: "change" },
      //   ],
      //   type: [
      //     {
      //       type: "array",
      //       required: true,
      //       message: "Please select at least one activity type",
      //       trigger: "change",
      //     },
      //   ],
      //   resource: [
      //     {
      //       required: true,
      //       message: "Please select activity resource",
      //       trigger: "change",
      //     },
      //   ],
      //   desc: [
      //     {
      //       required: true,
      //       message: "Please input activity form",
      //       trigger: "blur",
      //     },
      //   ],
      // },
    };
  },
  computed: {},
  methods: {},
  created() {
    
    let obj = {}
    this.formConfig.forEach(i => {
      obj[i.prop] = "";
    })
    this.form = obj;
    console.log(this.formConfig,this.form)
  },
  mounted() {},
  activated() {},
  watch: {},
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ui/edit-form/edit-form.vue